// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import { connect } from 'react-redux';
import Slider from 'react-slick';

import { openSignUpModal } from '../../redux/actions/authActions';

type Props = {
  openSignUpModal: () => void,
};

const Settings = {
  infinite: false,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 4,
  arrows: false,
  dots: false,
  variableWidth: true,
  responsive: [
    { breakpoint: 991, settings: { slidesToShow: 2, arrows: false, dots: true } },
    { breakpoint: 750, settings: { slidesToShow: 2, arrows: false, dots: true } },
    { breakpoint: 500, settings: { slidesToShow: 2, arrows: false, dots: true } },
  ],
};

const CTA_LIST = [
  {
    name: 'Book Treks and Heli Tours in Everest',
    img: 'https://s3.amazonaws.com/honeyguide/assets/heli-eve.jpg',
    imgLarge: 'https://s3.amazonaws.com/honeyguide/assets/heli-eve-l.jpg',
    link: '/treks'
  },
  {
    name: 'Book Flights to Lukla',
    img: 'https://s3.amazonaws.com/honeyguide/assets/lukla-filght.jpg',
    imgLarge: 'https://honeyguide.s3.amazonaws.com/assets/lukla-flight-l.jpg',
    link: '/flights',
  },
  {
    name: 'Book Hotels in Everest Region',
    img: 'https://s3.amazonaws.com/honeyguide/assets/eve-hotel.jpg',
    imgLarge: 'https://s3.amazonaws.com/honeyguide/assets/eve-hotel-l.jpg',
    link: '/lodges',
  },
  {
    name: 'Hire Guides for Everest Treks',
    img: 'https://s3.amazonaws.com/honeyguide/assets/eve-guide.jpg',
    imgLarge: 'https://s3.amazonaws.com/honeyguide/assets/eve-guide-l.jpg',
    link: '/guides',
  },
];

const ExtraCTA = ({ openSignUpModal }: Props) => (
  <Container className="py-4">
    <Row>
      <Col>
        <h2 className="text-uppercase text-center section-header">WITH HONEYGUIDE YOU CAN</h2>
        <hr className="hr--small mb-4 yellow" />
        <Slider {...Settings} className="package-slider">
          {CTA_LIST.map(({ img, imgLarge, name, link = '' }) => (
            <div className="pack-card">
              <div className="pack-card-banner">
                <a href={link} className="block" key={name}>
                  <picture className="pack-card-image">
                    <source srcSet={imgLarge} media="(min-width: 992px)"></source>
                    <img src={img} alt="" className="pack-card-image" />
                  </picture>
                </a>
                <div className="pack-card-detail-wrap">
                  <h6><a href={link} className="pack-card-name" key={name}>{name}</a></h6>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </Col>
    </Row>
  </Container>
);

const mapDispatchToProps = dispatch => ({
  openSignUpModal: () => dispatch(openSignUpModal()),
});

const ConnectedExtraCTA = connect(null, mapDispatchToProps)(ExtraCTA);

export default withRouter(ConnectedExtraCTA);



// WEBPACK FOOTER //
// ./src/screens/Landing/ExtraCTA.jsx